export const STATE_NAME = 'contactAdvertiser';

export enum State {
  INITIAL = 'initial',
  LOADING = 'loading',
  ERROR = 'error',
  LOADED = 'loaded',
  REDIRECT = 'redirect',
}
